import { CustomerCount, OptIn } from '@arrived/models';

import { affiliateApi, marketingApi } from '../api';

export async function getCustomerSubscriptions(cioId: string) {
  const response = await marketingApi.get<OptIn>(`/customerio/${cioId}`);
  return response.data;
}

export async function postCustomerSubscription(data: OptIn) {
  const response = await marketingApi.post<OptIn>(`customerio/unsubscribe`, data);
  return response.data;
}

export async function getCustomerCount() {
  const response = await marketingApi.get<CustomerCount>('/customerio/count');
  return response.data;
}

export async function trackTuneAffiliateConversion(urlPath: string) {
  const response = await affiliateApi.post(urlPath);
  return response.data;
}
